import { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export type FieldLimitType = {
	MIN?: number;
	MAX: number;
};

export const useStringLengthValidation = () => {
	const { formatMessage } = useIntl();

	const handleEmptyStringValidation = useCallback(
		(fieldLabel: string) =>
			(value = ''): string | undefined => {
				const { length } = value.trim();

				return length === 0 ? formatMessage(messages.missingValidation, { fieldLabel }) : undefined;
			},
		[formatMessage],
	);

	const handleStringLengthLimitValidation = useCallback(
		(fieldLabel?: string, fieldLimit?: FieldLimitType) =>
			(value = ''): string | undefined => {
				if (fieldLimit !== undefined && fieldLimit !== undefined) {
					const { length } = value.trim();

					if (fieldLimit.MIN !== undefined && fieldLimit.MIN > length) {
						return formatMessage(messages.minValidation, {
							fieldLabel,
							min: fieldLimit.MIN,
						});
					}

					if (fieldLimit.MAX < length) {
						return formatMessage(messages.maxValidation, {
							fieldLabel,
							max: fieldLimit.MAX,
						});
					}
				}

				return undefined;
			},
		[formatMessage],
	);

	return { handleEmptyStringValidation, handleStringLengthLimitValidation };
};
